import React,{useState,useEffect} from 'react';
import { withRouter, Link } from "react-router-dom";
import MetaTags from 'react-meta-tags';
import {getBlogListAction} from '../../Actions/User.action';
import BreadcrumbsComp from '../../../_Common/Breadcrumbs';
import moment from "moment";

const BlogPage = ({history}) => {
  const [blogList,setBlogList] = useState({});

  const getBlogListFunction = async()=>{
    let blogData = await getBlogListAction();   
    setBlogList(blogData);
  }

  useEffect(()=>{
    document.documentElement.scrollTop = 0;
    getBlogListFunction();
  },[]);

  return (
    <div>
      <MetaTags>
        <title>Recover - Virtual Physical Therapy California</title>
        <meta name="description" content="Read informative & engaging blogs on virtual physical therapy in California here. Get the right insights from the experts at Recover and increase your knowledge!" />
        <meta name="keywords" content="telehealth, Providers near me , Find A Provider, Online Therapy San Diego, Find the Right Provider, Teletherapy , Best Providers/Counselors Near Me in San Diego, Virtual Therapy, Clinical Psychologist, Find best Psychologist near me, Best Psychologists in San Diego, best physical therapy near me, physical therapy in californai, Providers near me, best psychologist near san diego, psychology today find a provider , recover healthcare san diego, top psychologist near me, psychotherapy san diego, physical therapy Clinic san diego, online physical therapy programs near san diego, physical therapy california, virtual physical therapy near san diego, advanced physical therapy, virtual pt in california, recover healthcare california, recovery health services san diego, physical therapy in california, find a provider in san diego, top rated physical therapy near san diego, physical therapy facilities near me, physical therapy around me, pt therapy near me, provider california, physical therapy san diego, physical therapy los angeles, telehealth solutions, select physical therapy los angeles, best recovery healthcare in san diego, telehealth solutions in san diego, good psychologist near me, clinical psychologist california, provider santa maria, digital telehealth solutions, physical therapy livermore ca, find a provider in california, how to find the right provider for me, san diego psychotherapy and wellness center, independent providers california, recover healthcare, recovery health services, best recovery healthcare, online provider san diego, physical therapy Clinic near me, Telehealth physical therapy California, Virtual physical therapy California, Face time physical therapy California, physical therapy treatment San Diego, provider San Diego, Telehealth physical therapy San Diego, Virtual physical therapy San Diego, Face time physical therapy San Diego, Independent Providers San Diego, Clinic Providers San Diego, provider Services San Diego" />
      </MetaTags>

      <section className="pad-reggis">
        <BreadcrumbsComp />

        <div className="container">
          <div className="row">
            <div  className="col-md-12">
              <div className="col section_title text-center">
                <h3>Blog</h3>
                <div className="decor"></div>
              </div>
            </div>

            <div className="col-md-8">
              {blogList && blogList.data && blogList.data.map((item, index)=>(
                <div className="bol-portion" key={index}>
                  <div className="img-wi">
                    <img
                     src={`${process.env.REACT_APP_STATIC_S3_URL+item.blogImg}`}
                     alt="example"
                     onError={(e) => {
                        e.target.src = "/static/img/blog-img.jpg"
                        e.target.style = ''
                     }}
                    />
                  </div>
                  <div className="inline-sect">
                    <div className="calendar-sec">
                      <div className="blog-month">
                        {item.createdAt?moment(item.createdAt, "YYYY-MM-DD").format("MMMM"):'-'}
                      </div>
                      <div className="blog-date">{item.createdAt?moment(item.createdAt, "YYYY-MM-DD").format("D"):'-'}</div>
                    </div>
                    <div className="blog-part-text">
                      <h4>{item.name?item.name:'-'}</h4>
                      <p>
                        {item.desc && item.desc.length > 200 ?(item.desc.replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ')).substring(0, 200)+'....':''}
                        {item.desc && item.desc.length < 200 ?item.desc.replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' '):'-'}
                      </p>
                      <Link to={{pathname:`blogs/${item?.slug.trim().toLowerCase().replace(/[\W_]+/g, '-').replace(/^-+|-+$/g, '')}`,  state:{id:item._id}}} className="btn btn-primary js-scroll-trigger">Read More</Link>
                    </div>
                  </div>
                </div>
              ))}
            </div> 

            <div className="col-md-4">
              <div className="right-sect-blog">
                <div className="recent-heading">
                  <h4>Recent Post</h4>
                </div>
                <div className="recent-b-lidt">
                  <ul>
                    {blogList && blogList.data && blogList.data.map((item, ind) => {
                      if (ind < 5) {
                        return (
                          <li key={ind}>
                            <Link to={{pathname:`blogs/${item?.slug.trim().toLowerCase().replace(/[\W_]+/g, '-').replace(/^-+|-+$/g, '')}`,  state:{id:item._id}}}>
                              {item.name?item.name:'-'}
                            </Link>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              </div> 
            </div>  
          </div>
        </div>
      </section>
    </div>
  );
}
export default withRouter(BlogPage);
